import React, { useMemo } from "react";

const CustomFieldSelector = ({
  value,
  onChange,
  placeholder,
  autoFocus = false,
  onSelect,
  customFields = [],
}) => {
  // Transform customFields object to array format
  const fieldsArray = useMemo(() => {
    // Convert object format { "field_name": true } to array format [{ name: "field_name", id: "field_name" }]
    const result = Array.isArray(customFields)
      ? customFields
      : Object.keys(customFields || {}).map((key) => ({ name: key, id: key }));

    return result;
  }, [customFields]);

  const handleFieldChange = (e) => {
    const selectedFieldName = e.target.value;
    onChange(selectedFieldName);

    if (onSelect && selectedFieldName) {
      const selectedField = fieldsArray.find(
        (field) => field.name === selectedFieldName,
      );
      if (selectedField) {
        onSelect(selectedField);
      }
    }
  };

  return (
    <select
      value={value}
      onChange={handleFieldChange}
      placeholder={placeholder}
      className="px-3 py-1 border-0.5 border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-pink focus:border-transparent min-w-[200px]"
      autoFocus={autoFocus}
    >
      <option value="">Select custom field</option>
      {fieldsArray.map((field) => (
        <option key={field.id} value={field.name}>
          {field.name}
        </option>
      ))}
    </select>
  );
};

export default CustomFieldSelector;
